// ======================================================================
// File Name       : UserHistoryStudentResultContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as UserHistoryStudentAction from '../../../actions/UserHistoryStudentAction';
import UserHistoryStudentDetailTitle from '../../../components/userHistory/student/UserHistoryStudentDetailTitle';
import UserHistoryStudentResultDrillInfo from '../../../components/userHistory/student/UserHistoryStudentResultDrillInfo';
import UserHistoryStudentResultDrillResult from '../../../components/userHistory/student/UserHistoryStudentResultDrillResult';
import HtmlDialog from '../../../components/userHistory/student/HtmlDialog';
import { convertObjectToList } from '../../../utils/UserUtils';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../../constants/index';
import Header from '../../../components/Header';
import { USER_HISTORY_COURSE_STUDENT_DETAIL, USER_HISTORY_STUDENT_DETAIL } from '../../../constants/PathConstants';
import CustomLink from '../../../components/button/CustomLink';

class UserHistoryStudentResultContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      userSecernId: null,
      itemSecernId: null,
      drillSecernId: null,
      learningStartTime: '',
      learningEndTime: '',
      questionSecernIdList: [],
      startPosition: 0,
      returnMaxNum: null,
      drillStartDate: '',
    };
    this.goBack = this.goBack.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    this.getUserHistoryInfoByHistoryHash(match.params.id);
  }

  goBack() {
    // Step 9.0.0 START
    const { match } = this.props;
    if (match && 
      (match.path.indexOf('userHistory/courseGrades/result') > -1) || 
      (match.path.indexOf('userHistory/courseGrades/course/result') > -1)) {
      this.props.history.goBack();
    }
    // Step 9.0.0 END
    this.props.history.goBack();
  }

  getUserHistoryInfoByHistoryHash(historyHash) {
    try {
      const { learningHistoryList } = this.props;
      const matchItem = learningHistoryList.filter(item => item.historyHash === historyHash);
      const {
        userSecernId,
      } = matchItem[0];
      this.setState(
        {
          ...this.state,
          userSecernId,
        },
        () => {
          this.getStudentResult(historyHash);
        },
      );
    } catch (error) {
      console.log(error);
      this.goBack();
    }
  }

  openDialog(questionObj) {
    let drillStartDate = '';
    if (this.props.drillResultByStd && this.props.drillResultByStd.drillStartDate) {
      drillStartDate = this.props.drillResultByStd.drillStartDate;
    }
    const params = {};
    params.drillSecernId = this.props.drillResultByStd.drillSecernId;
    params.questionSecernId = questionObj.questionSecernId;
    params.userSecernId = this.state.userSecernId;
    params.drillStartDate = drillStartDate;
    const request = [];
    request.push(
      this.props.dispatch(UserHistoryStudentAction.getQuestionHistoryReviewHtml(params)),
    );
    Promise.all(request).then((res) => {
      this.showDialog(res);
    });
  }

  showDialog(res) {
    if (res && res[0]) {
      this.setState({
        redirectUri: res[0],
        showModal: true,
      });
    }
  }

  closeDialog() {
    this.setState({
      showModal: false,
    });
  }
  getStudentResult(historyHash) {
    const params = {};
    const {
      userSecernId,
    } = this.state;
    params.historyHashList = [
      historyHash,
    ];
    this.props.dispatch(UserHistoryStudentAction.getStudentResult(params));
  }

  render() {
    const {
      drillResultByStd,
      userList,
      groupList,
      groupRelationList,
      courseStatusList,
      learningHistoryList,
      recordNum,
      parentPathSub,
    } = this.props;
    const { userSecernId, startPosition, showModal } = this.state;

    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          text="ユーザー別履歴一覧に戻る"
          onClick={this.goBack} // Step 9.0.0
          icon="bi bi-chevron-left"
        />
        <Header name="ユーザー別履歴情報(ドリル)の詳細"/>
        <UserHistoryStudentDetailTitle
          groupList={groupList}
          userList={userList}
          groupRelationList={groupRelationList}
          userSecernId={userSecernId}
          isViewingResult
        />
        <UserHistoryStudentResultDrillInfo
          drillResultByStd={drillResultByStd}
        />
        <UserHistoryStudentResultDrillResult
          questionResultList={drillResultByStd.questionResultList}
          openDialog={this.openDialog}
        />
        <HtmlDialog
          show={showModal}
          closeDialog={this.closeDialog}
          redirectUri={this.state.redirectUri}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userHistoryStudent, userSecernId } = state;
  const { parentPathSub } = state.page;
  const { userHistoryData, userHistoryDetailData } = userHistoryStudent;
  const { groupList, groupRelationList, userList, courseStatusList, courseList } = userHistoryData;
  const { learningHistoryList, recordNum, drillResultByStd, redirectUri } = userHistoryDetailData;

  return {
    ...{
      drillResultByStd,
      redirectUri,
      userHistoryData,
      userHistoryStudent,
      groupList,
      groupRelationList,
      recordNum,
      userList,
      courseList,
      courseStatusList,
      learningHistoryList,
      parentPathSub,
    },
  };
};

export default connect(mapStateToProps)(UserHistoryStudentResultContainer);
